import { memo, useEffect } from "react";
import { useImmer } from "use-immer";
import st from "./Gallery.module.scss";
import SortableList, { SortableItem } from "react-easy-sort";
import { arrayMoveImmutable } from 'array-move'

type GalleryType = {
    imgs?: Array<any>,
    onSort?: any,
    onChooseFiles?: any,
    checkImages?: any,
    mainImg?: string,
    setMainImg?: any,
    removeImages?: any,
}

function Gallery({ imgs = [], setMainImg, onSort, onChooseFiles, checkImages, mainImg = '', removeImages }: GalleryType) {

    const [amount, setAmount] = useImmer(0);
    const [images, setImage] = useImmer([...imgs]);
    const [checkedFiles, setChecked] = useImmer<string[]>([]);

    useEffect(() => {
        setImage(imgs as any);
    }, [imgs]);

    useEffect(() => {
        setAmount(images.length);
    }, [images]);

    const onImageChange = (evt: any): any => {
        let target = evt.target, files: FileList[] = target.files;
        if (files && files.length) {
            let arrayOfUrl: any = [];
            Array.from(files).forEach((file: any) => {
                arrayOfUrl.push(URL.createObjectURL(file));
            })
            setImage([...imgs, ...arrayOfUrl] as any);
        }
        if (typeof onChooseFiles == "function") {
            onChooseFiles(files);
        }
    }
    const onSortEnd = (oldIndex: number, newIndex: number) => {
        let newArr = arrayMoveImmutable(images, oldIndex, newIndex);
        setImage(() => {
            return newArr;
        });
        if (typeof onSort == "function") {
            onSort(newArr);
        }
    };

    return (
        <div className={st.galleryBlock}>
            <div className={st.galleryTop}>
                <div className={st.galleryTopBox}>
                    <div className={st.setMainImg} onClick={(e) => setMainImg(e, checkedFiles[0])}>Set main </div>
                    <p className={st.amount}>{amount} photos</p>
                </div>
                {<div className={st.removeBtn} onClick={() => removeImages(checkedFiles[0])}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                        <path d="M24.0228 7.60506H20.4023L20.3439 6.79012C20.3054 6.25329 19.8683 5.83789 19.342 5.83789H13.5104C12.9841 5.83789 12.5471 6.25329 12.5086 6.79012L12.4502 7.60506H8.82925C8.35403 7.60506 7.96875 7.999 7.96875 8.48509C7.96875 8.971 8.35403 9.36495 8.82925 9.36495H24.0228C24.4981 9.36495 24.8833 8.971 24.8833 8.48509C24.8833 7.99919 24.4981 7.60524 24.0228 7.60524V7.60506ZM13.2467 6.84551C13.2567 6.70506 13.3725 6.59501 13.5103 6.59501H19.3418C19.4796 6.59501 19.5954 6.70506 19.6054 6.84551L19.6598 7.60506H13.1921L13.2465 6.84551H13.2467Z" fill="#0076E4" />
                        <path d="M9.86328 22.575C9.9275 23.4701 10.6563 24.1627 11.5341 24.1627H21.3188C22.1965 24.1627 22.9254 23.4699 22.9896 22.575L23.8881 10.0371H8.96484L9.86328 22.575ZM22.2514 22.5196C22.234 22.7611 22.129 22.9851 21.9555 23.15C21.782 23.3149 21.556 23.4058 21.319 23.4058H11.5341C11.2971 23.4058 11.0711 23.3149 10.8976 23.15C10.7241 22.9851 10.6189 22.7613 10.6017 22.5196L9.76149 10.7939H23.0916L22.2514 22.5196Z" fill="#0076E4" />
                        <path d="M16.4248 21.2518C16.6293 21.2518 16.795 21.0824 16.795 20.8733V13.0083C16.795 12.7993 16.6293 12.6299 16.4248 12.6299C16.2203 12.6299 16.0547 12.7993 16.0547 13.0083V20.8733C16.0547 21.0824 16.2203 21.2518 16.4248 21.2518Z" fill="#0076E4" />
                        <path d="M12.9707 20.8974C12.9831 21.0977 13.146 21.2518 13.3397 21.2518C13.3476 21.2518 13.3556 21.2516 13.3636 21.251C13.5676 21.2378 13.7224 21.058 13.7095 20.8493L13.22 12.9843C13.2071 12.7758 13.0311 12.6174 12.8271 12.6307C12.6232 12.6439 12.4683 12.8237 12.4812 13.0324L12.9707 20.8974Z" fill="#0076E4" />
                        <path d="M19.4912 21.251C19.4992 21.2516 19.507 21.2518 19.5151 21.2518C19.7088 21.2518 19.8715 21.0977 19.8841 20.8974L20.3736 13.0324C20.3865 12.8239 20.2316 12.6441 20.0277 12.6307C19.8239 12.6174 19.6479 12.7758 19.6347 12.9843L19.1453 20.8493C19.1323 21.0578 19.2872 21.2376 19.4912 21.251Z" fill="#0076E4" />
                    </svg>
                </div>}
            </div>

            <SortableList
                onSortEnd={onSortEnd}
                className={st.imgLine}
                draggedItemClassName={st.dragged}
                allowDrag={true}
            >
                <div className={st.rowImg}>
                    <div className={st.chooseFile}>
                        <input type="file" multiple={true} className={st.file} onChange={onImageChange} accept="image/*" />
                    </div>
                    {
                        images?.map((img, index) => {
                            return (
                                <SortableItem key={index}>
                                    <div className={st.choosedImg +
                                        ' ' + (!imgs?.includes(img) ? st.time : "") +
                                        ' ' + (checkedFiles?.includes(img) ? st.checked : "") +
                                        ' ' + (img.includes(mainImg) ? st.mainImg : '')}
                                        style={{ backgroundImage: `url(${img})` }} onClick={(e) => {
                                            let newCheckedFiles: any = [];
                                            if (newCheckedFiles.includes(img)) {
                                                newCheckedFiles.splice(newCheckedFiles.indexOf(img), 1);
                                            } else {
                                                newCheckedFiles.push(img);
                                            }
                                            setChecked((draft => {
                                                return newCheckedFiles;
                                            }))
                                            if (typeof checkImages == "function") {
                                                checkImages(newCheckedFiles);
                                            }
                                        }}>
                                        {img?.includes(mainImg) && mainImg?.length > 2 ? (<div className={st.marker}>Main</div>) : false}
                                        <div className={st.orderNumber}>{index + 1}</div>
                                        <span></span>
                                    </div>



                                    {/* <div
                                    className={st.choosedImg +
                                        ' ' + (!imgs?.includes(img) ? st.time : "") +
                                        ' ' + (checkedFiles?.includes(img) ? st.checked : "") +
                                        ' ' + (img.includes(mainImg) ? st.mainImg : '')}
                                    style={{ backgroundImage: `url(${img})` }} onClick={(e) => {
                                        let newCheckedFiles = [...checkedFiles];
                                        if (newCheckedFiles.includes(img)) {
                                            newCheckedFiles.splice(newCheckedFiles.indexOf(img), 1);
                                        } else {
                                            newCheckedFiles.push(img);
                                        }
                                        setChecked((draft => {
                                            return newCheckedFiles;
                                        }))
                                        if (typeof checkImages == "function") {
                                            checkImages(newCheckedFiles);
                                        }
                                    }}>
                                    {img?.includes(mainImg) && mainImg?.length > 2 ? (<div className={st.marker}>Main</div>) : false}

                                    <div className={st.orderNumber}>{index + 1}</div>
                                    <div className={st.controlPanel}>
                                        <div className={st.marker + ' ' + st.marker_red + ' ' + st.hiddenHover}
                                            onClick={(e) => removeImages(img)}>Remove Img
                                        </div>
                                        {img?.includes(mainImg) ? false :
                                            imgs?.includes(img) ?
                                                <>
                                                    <div
                                                        className={st.marker + ' ' + st.marker_green + ' ' + st.hiddenHover}
                                                        onClick={(e) => setMainImg(e, img)}>Set as Main Img
                                                    </div>
                                                </> : <></>}
                                    </div>
                                </div> */}
                                </SortableItem>
                            );
                        })}
                </div>

            </SortableList>

        </div>

    );
}

export default memo(Gallery);